import { Link } from 'react-router-dom'
import { Check } from 'lucide-react'

interface EpisodeProgressProps {
  moduleId: number
  currentEpisode: number
  /** Quantidade real de episódios do módulo. Default 0 = não renderiza
   *  (chamadores devem passar o valor real; o default antigo era 6
   *  hardcoded, o que mostrava 1-2-3-4-5-6 mesmo pra módulos com 1 ep). */
  totalEpisodes?: number
}

const EpisodeProgress = ({ moduleId, currentEpisode, totalEpisodes = 0 }: EpisodeProgressProps) => {
  if (totalEpisodes <= 1) return null
  const episodes = Array.from({ length: totalEpisodes }, (_, i) => i + 1)

  return (
    <div className="flex items-center justify-center gap-2 py-4">
      {episodes.map((ep, index) => (
        <div key={ep} className="flex items-center">
          <Link
            to={`/episode/${moduleId}/${ep}`}
            className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold transition-all duration-300 ${
              ep < currentEpisode
                ? 'bg-primary/20 text-primary border border-primary'
                : ep === currentEpisode
                  ? 'gradient-primary text-primary-foreground glow-primary'
                  : 'bg-muted text-muted-foreground hover:bg-secondary'
            }`}
          >
            {ep < currentEpisode ? <Check className="w-4 h-4" /> : ep}
          </Link>
          {index < episodes.length - 1 && (
            <div
              className={`w-6 md:w-8 h-0.5 ${ep < currentEpisode ? 'bg-primary' : 'bg-border'}`}
            />
          )}
        </div>
      ))}
    </div>
  )
}

export default EpisodeProgress
